const templatesEbayGeneral = [
  {
    id: 1,
    text: "Apologies for the delay in our reply.",
  },
  {
    id: 2,
    text: "Apologies for the delay in receiving your order.",
  },
  {
    id: 3,
    text: "Unfortunately, we are unable to modify the prices as listed on the site or manually apply any discounts to an order.",
  },
  {
    id: 4,
    text: "Unfortunately we are not in control of the promotions or offers. The offers are available for limited times and their details are listed on the site.",
  },
  {
    id: 5,
    text: "All HP printers come with one starter ink cartridge that is about one third full, meant to get the device up and running.",
  },
  {
    id: 6,
    text: "All HP products come with the standard 1 year manufacturers warranty.",
  },
  {
    id: 7,
    text: "All HP items will come new and factory sealed.",
  },
  {
    id: 20,
    text: "All HP Store printers will come with starter ink included. You may find further information related to this device under the full product specs by performing a search for the printer on the HP Online Store.\nhttps://www.hp.com/gb-en/shop/ ",
  },
  {
    id: 8,
    text: "The invoice is created automatically and will be sent to you within 2-3 days of the order processing and shipping.",
  },
  {
    id: 9,
    text: "Our apologies if you have received an email that did not format properly, the IT department is currently working on a fix. If you have a query in relation to your order, please provide your order number in format XX-XXXXX-XXXXX and we will look into this.",
  },
  {
    id: 10,
    text: "We are happy to hear that you are happy with your order!",
  },
  {
    id: 11,
    text: "For a full technical explanation of the product specs, our support team contact info can be found below:\nhttps://www.hp.com/gb-en/shop/faq.aspx?p=customer-care#useful-links",
  },
  {
    id: 12,
    text: "Further information related to the Instant Ink subscription can be found below:\nhttps://instantink.hpconnected.com/uk/en/l/",
  },
  {
    id: 13,
    text: "This device will come with the Microsoft  Office pack installed, but not with the subscription key needed to access its full services.",
  },
  {
    id: 14,
    text: "On the product page, the dropdown menus 'What's in the box' and 'Choose item' allow you to select the quantity and type of ink.",
  },
  {
    id: 22,
    text: "Our full range of products can be found on the HP Store, you may use the advanced search filters to find an item that suits your needs. If you prefer to purchase the item via our Ebay store, you may perform a search for that item here on Ebay.\nhttps://www.hp.com/gb-en/shop/",
  },
];

const templatesEbayOrderStatus = [
  {
    id: 20,
    text: "Our records show that your order has been delivered.\n\nOur apologies for the delays and inconvenience seen with this order. ",
  },
  {
    id: 21,
    text: "Our records show that your order has been shipped to the courier and is out for delivery today. Please see your tracking link below:\n\nOur apologies for the delays and inconvenience seen with this order. ",
  },
  {
    id: 22,
    text: "Our records show that your order has been shipped to the courier, please see your tracking below. As soon as DPD scan this into their system, your tracking will update with further ETA information.\n\n Our apologies for the delays and inconvenience seen with this order.",
  },

  {
    id: 3,
    text: "Unfortunately there was an error processing this order and it is being fully cancelled. You'll be notified automatically once this is complete. This will not ship and you will not be fully charged. If there is a charge on your end currently, it will be fully refunded.",
  },
  {
    id: 4,
    text: "Our apologies for the delay in receiving your order. We have escalated your case to the warehouse to try and expedite this out to the courier. As soon as it ships to the courier, you will receive the tracking link automatically.",
  },
];

const templatesEbayReturns = [
  {
    id: 1,
    text: "We are unable to assist directly as we are outside the 30 days after delivery.",
  },
  {
    id: 2,
    text: "We are sorry to hear that you are having these issues with your device.",
  },
  {
    id: 3,
    text: "For troubleshooting assistance, our support team contact info can be found below\nhttps://www.hp.com/gb-en/shop/faq.aspx?p=customer-care#useful-links",
  },
  {
    id: 4,
    text: "If they are unable to assist, or you simply wish to return this item, please raise the return and refund request from your end as seen below:",
  },
  {
    id: 5,
    text: "To start a return, select the item you want to send back from your recent purchases above, or follow the steps below:\n1.        Find the item in your Purchase history and select Return this item.\n2.        Select your reason for the return.\n3.        Select Send.\n\nWe will then raise your claim accordingly",
  },
  {
    id: 6,
    text: "Please find attached your DPD return label, valid for 5 working days.\n\nPlease remember to get a receipt from the post office when you drop this off. ",
  },
];

export { templatesEbayGeneral, templatesEbayOrderStatus, templatesEbayReturns };
